import React, { ReactElement } from 'react'
import { VStack } from '@chakra-ui/react'
import { useTrail, config } from 'react-spring'
import { useInView } from 'react-intersection-observer'

import CheckListItem from './CheckListItem'

interface Props {
  fillColor: string
  strokeColor: string
  labels: string[]
}

function CheckList({ fillColor, strokeColor, labels }: Props): ReactElement {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  const trail = useTrail(labels.length, {
    to: {
      opacity: inView ? 1 : 0,
      // transform: inView ? 'translate3d(0, 0px, 0)' : 'translate3d(0, 32px, 0)',
      transform: inView ? 'scale(1)' : 'scale(0.4)',
    },
    config: config.gentle,
  })

  return (
    <VStack
      ref={ref}
      spacing="4"
      sx={{
        alignItems: 'stretch',
        maxWidth: {
          base: 'unset',
          'lg+': '541px',
        },
        width: '100%',
      }}
    >
      {labels.map((label, index) => {
        return (
          <CheckListItem
            key={label}
            style={trail[index]}
            fillColor={fillColor}
            strokeColor={strokeColor}
            label={label}
          />
        )
      })}
    </VStack>
  )
}

CheckList.defaultProps = {}

export default CheckList
